import React from 'react';
import { Progress } from 'antd';
import './CircleGraph.scss';
import { circleGraphConfig } from './CircleGraphConfig';
import { getUsageStrokeColor } from 'components/Fragments/CreditUsageCircleGraph/CreditUsageCircleGraph';
import Label from 'components/form/Label/Label';

function CircleGraph(props) {
  const datatestid = props.datatestid ? `${props.datatestid}CircleGraph` : null;
  let className = `circleGraph`;
  const strokeFill = getUsageStrokeColor(props.percent);

  const titleFragment = type => {
    return props.titleText ? (
      <CircleGraphTitle
        titleText={props.titleText}
        subTitleText={props.subTitleText}
        pageType={props.pageType}
        datatestid={`${datatestid}-${type}`}
      />
    ) : null;
  };

  if (props.doubleGraph) {
    className += ` doubleGraph`;
  }
  if (props.className) {
    className += ` ${props.className}`;
  }

  return (
    <div data-testid={datatestid} className={className}>
      <Progress
        className={`mobileGraph ${
          props.strokeFill ? props.strokeFill : strokeFill
        } ${props.styleType ? props.styleType : ''}`}
        percent={props.percent}
        success={{ percent: props.successPercent }}
        width={props.mobileWidth ? props.mobileWidth : 162}
        strokeWidth={props.strokeWidth ? props.strokeWidth : 7}
        type="circle"
        format={() => titleFragment('mobile')}
      />
      <Progress
        className={`desktopGraph ${
          props.strokeFill ? props.strokeFill : strokeFill
        } ${props.styleType ? props.styleType : ''}`}
        percent={props.percent}
        success={{ percent: props.successPercent }}
        width={props.width ? props.width : 240}
        strokeWidth={props.strokeWidth ? props.strokeWidth : 7}
        type="circle"
        format={() => titleFragment('desktop')}
      />
    </div>
  );
}

export default CircleGraph;

function CircleGraphTitle(props) {
  const datatestid = props.datatestid ? `${props.datatestid}` : null;
  return (
    <React.Fragment>
      {props.titleText && (
        <Label
          datatestid={`${datatestid}-title`}
          ariaHidden="true"
          tabIndex="-1"
          type="H1-graph"
          className={
            props.pageType
              ? circleGraphConfig[props.pageType]['title']
              : 'titleText'
          }
        >
          {props.titleText}
        </Label>
      )}
      {props.subTitleText && (
        <Label
          datatestid={`${datatestid}-subTitle`}
          ariaHidden="true"
          tabIndex="-1"
          type="H5"
          className={
            props.pageType
              ? circleGraphConfig[props.pageType]['subTitle']
              : 'subTitleText'
          }
        >
          {props.subTitleText}
        </Label>
      )}
    </React.Fragment>
  );
}
